module.exports = __webpack_public_path__ + "static/4-tips-conten1-76600ced0e9e022699e1472287776793.png";